import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { catchError, retry, map } from 'rxjs/operators'
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(
        protected router: Router,
        protected http: HttpClient, 
    ) {}
    private loggedIn = new BehaviorSubject<boolean>(this.isLoggedIn);
    
    loginStatus$: Observable<boolean> = this.loggedIn.asObservable();
    me: any;
    isLoginPage: boolean = false;
    get isLoggedIn() {
        const token = localStorage.getItem('token');
        return !!token;
    }

    login() {
        const token = localStorage.getItem('token');
        if (token) {
            this.loggedIn.next(true);
            let url = localStorage.getItem('redLink');
            url = url.replace(/"/g, ''); 
            this.router.navigateByUrl(url);
        } else {
            this.loggedIn.next(false);
        }
    }

    logout() {
        localStorage.removeItem('token');
        this.loggedIn.next(false);
    }
    removeAuth() {
        localStorage.removeItem('token');
        localStorage.removeItem('redLink');
        localStorage.removeItem('api_token');
        localStorage.removeItem('rol_id');
        localStorage.removeItem('user_id');
    }

    validateURL(me): Promise<void> {
        return new Promise((resolve, reject) => {
            const publicPages = ['/login', '/public'];
            let currentUrl = this.router.url;
    
            // Ignorar los parámetros de consulta para la validación
            if (currentUrl.includes('?')) {
                currentUrl = currentUrl.split('?')[0];
            }
            if (publicPages.includes(currentUrl)) {
                this.isLoginPage = false;
                // this.removeAuth();
                resolve();
            } else {
                this.me = me;
                let actualPage;
                let actualCompany;
                let validURL = false;
                const companies = this.me.companies;
    
                companies.forEach(company => {
                    company.pages.forEach(page => {
                        if (currentUrl === page.url) {
                            validURL = true;
                            actualPage = page;
                            actualCompany = company;
                        }
                    });
                });
    
                if (!validURL) {
                    this.router.navigateByUrl(me.link_redirection).then(() => {
                        resolve();
                    }).catch((error) => {
                        reject(error);
                    });
                } else {
                    // Registrar la interacción si la URL es válida
                    this.tagService(
                        me.id,
                        `${me.first_name} ${me.last_name}`,
                        actualCompany.id,
                        actualCompany.name,
                        actualPage.id,
                        actualPage.nombre,
                        "page_view"
                    ).subscribe();
                    resolve();
                }
            }
        });
    }

    tagService(user_id, user_name,company_id, company_name,page_id, page_name,interaction_type): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const data = {
            "user_id": user_id,
            "user_name": user_name,
            "company_id": company_id,
            "company_name": company_name,
            "page_id": page_id,
            "page_name": page_name,
            "interactionType": interaction_type
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.apiUrl}/tagRegister/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    protected handleError (error: HttpErrorResponse) {
        let publicPages = ['/login', '/validate_email'];
        let currentPage = this.router.url
        if (currentPage.includes('?')) {
            currentPage = currentPage.split('?')[0]
        }
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message)
        } else if (publicPages.includes(currentPage)) {
            console.error('An error occurred:', error.error.message)
        } else {
            console.error(`Backend returned code ${error.status}, ` + `body was:`)
            console.error(error)
            if (error.status === 401) {
                this.logout();
                this.router.navigate(['/login']);
            }
        }
        return throwError({
            message: 'Something bad happened; please try again later.',
            code: error.status
        })
    }
}